module.exports = __webpack_public_path__ + "img/A39.png";